import React, { memo } from "react";
import { cn } from "utils";
import { BillingCycleType } from "../types";

import { BillingCycle } from "../constants";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Member/Subscription/BillingToggle/index";

const I18n = I18nUtil.createScoped(Translations);

interface BillingToggleProps {
  initialBillingCycle?: BillingCycleType;
  onChange?: (cycle: BillingCycleType) => void;
  annualDiscount?: number;
}

const BillingToggle: React.FC<BillingToggleProps> = ({
  initialBillingCycle = BillingCycle.YEAR,
  onChange,
  annualDiscount = 37,
}) => {
  const handleToggle = (cycle: BillingCycleType) => {
    onChange?.(cycle);
  };

  const cycles: {
    key: BillingCycleType;
    label: string;
    badge?: React.ReactNode;
  }[] = [
    { key: BillingCycle.WEEK, label: I18n.t("Weekly") },
    { key: BillingCycle.MONTH, label: I18n.t("Monthly") },
    {
      key: BillingCycle.YEAR,
      label: I18n.t("Annual"),
      badge: (
        <div className="md:px-[6px] px-[4px] py-[2px] bg-background_auralv3_overlay100 rounded flex justify-center items-center">
          <div className="text-center body_medium_s text-content_primary">
            {I18n.t("%{var0}% OFF", { var0: annualDiscount })}
          </div>
        </div>
      ),
    },
    {
      key: BillingCycle.LIFETIME,
      label: I18n.t("Lifetime"),
      badge: (
        <div className="md:px-[6px] px-[4px] py-[2px] bg-background_auralv3_overlay100 rounded flex justify-center items-center">
          <div className="text-center body_medium_s text-content_primary">
            {I18n.t("Best Value")}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-row justify-center items-center">
      <tab-indicator
        className="flex flex-row items-center gap-1 rounded-full bg-background_white_overlay5 p-2 [--capsule-bg-color:var(--edgen-background\_solid\_neutral\_primary)] [--capsule-border-radius:999px] [--animation-duration:0.2s]"
        effect="capsule"
      >
        {cycles.map(({ key, label, badge }) => (
          <div
            key={key}
            data-openreplay-label="member_billingtoggle_click"
            role="tab-item"
            className={cn(
              "lg_switch_group_atoms flex items-center justify-center gap-2.5 px-3 py-2 rounded-full cursor-pointer",
              "body_medium_l whitespace-nowrap",
            )}
            data-actived={initialBillingCycle === key}
            onClick={() => handleToggle(key)}
          >
            <span>{label}</span>
            {badge}
          </div>
        ))}
      </tab-indicator>
    </div>
  );
};

export default memo(BillingToggle);
